// ======================================================================
// File Name       : LiveReservedSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Col, Button } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';
import { VALIDATE_TYPE } from '../../constants/index';
import ReduxFormPaging from '../ReduxFormPaging';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../constants/UserAttributeConstants';
import { LIVE_FORMAT_NUM, TOTAL_AVAILABLE_TIME } from '../../constants/UsageSettingLiveConstant';
import CustomButton from '../button/CustomButton';

class LiveReservedSearch extends React.Component {
  render() {
    const {
      enableReservingTimeTxt,
      reservingTimeTxt,
      onSearchBtnClick,
      invalid,
      userAttributeKeyNum,
    } = this.props;
    return (
      <div>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSearchBtnClick();
          }}
          className='form-horizontal'
        >
          <Col sm={12}>
            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>予約状況</Col>
              <Col sm={8} className="padding-left-clear padding-top-bottom-10">
                {enableReservingTimeTxt && (
                  <div>
                    <span>予約可能時間　残</span>
                    <span style={{ fontWeight: 'bold' }}>
                      {enableReservingTimeTxt.h}
                    </span>
                    <span>時間</span>
                    <span style={{ fontWeight: 'bold' }}>
                      {enableReservingTimeTxt.m}
                    </span>
                    <span>分　現在</span>
                    <span style={{ fontWeight: 'bold' }}>{reservingTimeTxt.h}</span>
                    <span>時間</span>
                    <span style={{ fontWeight: 'bold' }}>{reservingTimeTxt.m}</span>
                    <span>分予約済み</span>
                  </div>
                )}
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={12}>
                <p>検索する項目を指定してください</p>
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                ライブ名
              </Col>
              <Col sm={7}>
                <RenderField type="text" name="liveName" label="ライブ名" />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                ライブ開催者名
              </Col>
              <Col sm={7}>
                <RenderField type="text" name="organizerUserName" label="ライブ開催者名" />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                ライブ形式
              </Col>
              <Col sm={7} className="padding-top-10">
                <RenderField
                  inline
                  className="padding-top-clear"
                  type="radio"
                  name="liveFormat"
                  value=""
                  label="選択なし"
                  normalizeRadio
                />
                <RenderField
                  inline
                  className="padding-top-clear"
                  type="radio"
                  name="liveFormat"
                  value={LIVE_FORMAT_NUM.ONE_WAY}
                  label="片方向"
                  normalizeRadio
                />
                <RenderField
                  inline
                  className="padding-top-clear"
                  type="radio"
                  name="liveFormat"
                  value={LIVE_FORMAT_NUM.TWO_WAY}
                  label="双方向"
                  normalizeRadio
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                実施日
              </Col>
              <Col sm={3}>
                <RenderField
                  type="datetime"
                  name="liveStartFrom"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={1} className="text-center" as={Form.Label}>
                ～
              </Col>
              <Col sm={3}>
                <RenderField
                  type="datetime"
                  name="liveStartTo"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={12}>
                <RenderField
                  name="dateTimeMinMax"
                  type="dateTimeMinMax"
                  validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                  keyDateFrom={'liveStartFrom'}
                  keyDateTo={'liveStartTo'}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                自由記述領域
              </Col>
              <Col sm={2}>
                <RenderField
                  type="selectbox"
                  name="userAttributeKeyNum"
                  label="自由記述領域"
                  value={userAttributeKeyNum}
                  data={USER_ATTRIBUTE_KEY_NUM_LIST}
                />
              </Col>
              <Col sm={5}>
                <RenderField type="text" name="userAttributeSearchText" maxLength={16384} />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                実施済みライブを含む
              </Col>
              <Col sm={7} className="padding-top-10">
                <RenderField
                  className="padding-top-clear"
                  type="checkbox"
                  name="includeCompletedLive"
                />
              </Col>
            </Form.Group>
          </Col>
          <Form.Group className="margin-top-20 text-center">
            <Col sm={12} className="padding-left-right-clear">
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                type="submit"
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

export default LiveReservedSearch;
